// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#V-95452820-9A7F-4EBA-A6A9-D80558B05A7C .invoice-list-factor-row > td {\n  border-bottom: 4px solid black;\n}\n", "",{"version":3,"sources":["webpack://src/Sell/invoicesList/invoicesList.less"],"names":[],"mappings":"AACI;EACI,8BAAA;AAAR","sourcesContent":["#V-95452820-9A7F-4EBA-A6A9-D80558B05A7C{\n    & .invoice-list-factor-row>td{\n        border-bottom: 4px solid black;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
